import React from "react";
import Alert from "react-s-alert";
import {Checkbox, styled} from "@reside/ui";

import {FacilityStatusEnum} from "../../../../utils/types/facility";
import {useFetchFacilitiesQuery} from "../../../../routers/AdminAppRefresh";
import {useUpdateFacilityStatusMutation} from "../../hooks";

type Props = Readonly<{
  facilityId: string;
  includeInReporting: boolean;
}>;

/**
 * Reside admin setting of an inactive facility: whether its workflows are still included in reporting.
 */
export const FacilityReportingToggle = ({
  facilityId,
  includeInReporting,
}: Props) => {
  const {fetchFacilitiesQuery} = useFetchFacilitiesQuery();
  const {mutate: updateStatus, isLoading} = useUpdateFacilityStatusMutation();

  const onToggle = () =>
    updateStatus({
      facilityId,
      status: FacilityStatusEnum.INACTIVE,
      includeInReporting: !includeInReporting,
      onSuccess: async () => {
        await fetchFacilitiesQuery();
        Alert.success(
          includeInReporting
            ? "The facility's workflows are no longer included in reporting"
            : "The facility's workflows are included in reporting again",
        );
      },
    });

  return (
    <Label data-test-id="facilityReportingToggle">
      <Checkbox
        name="includeInReporting"
        value="yes"
        checked={includeInReporting}
        onChange={onToggle}
        disabled={isLoading}
      />
      Include this facility&apos;s workflows in reporting
    </Label>
  );
};

const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  color: #203c63;
  white-space: nowrap;
  cursor: pointer;
`;
